import { Box, Grid, Typography } from "@mui/material";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";
const Vision = () => {
  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(white 85%, #fbe080 85%)`,
        backgroundColor: "white",
        backgroundSize: "40%",
      }}
    >
      <Grid
        container
        sx={{
          backgroundImage: `linear-gradient(0.35turn, #e6b40065 100%, transparent),url(${"https://website-img.polycaik.com/w/asset/435ddacdccdc43bd91556116e3e3e701.jpeg"})`,
          backgroundPosition: { xs: `right center`, md: `right center` },
          backgroundRepeat: `no-repeat`,
          backgroundSize: `cover`,
          justifyContent: `flex-start`,
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: (theme) => `${theme.palette.grey[900]}88`,
          }}
        >
          <Box sx={{ py: 9, px: `10%` }}>
            {getLayoutView(
              <>
                JUST{" "}
                <span style={{ fontFamily: "Lato-Bold" }}>IMAGINE</span>{" "}
              </>,
              [
                getLayoutText(
                  <>
                    Creating games should be as easy as writing a book or making
                    a painting. There are so many stories out there in the world
                    that need to be discovered. Stories of long-lost cultures
                    and ancient traditions make us reminisce about the world
                    around us. Imagine representing the royal expeditions of
                    Mansa Musa of Mali or the thrills of Madagascar in a game,
                    or even the extraordinary life of a civil rights leader in
                    America.
                  </>,
                  {
                    fontSize: "16px",
                    fontFamily: "Lato-Bold",
                    lineHeight: 2.25,
                  },
                ),
              ],
              [12],
              {
                p: 0,
                backgroundColor: `transparent`,
                "& .MuiTypography-root:not(.MuiTypography-caption)": {
                  color: `white`,
                },
              },
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Vision;
